export default "__VITE_ASSET__Ba7XneC1__"